export const createPermissionsParam = (rolesUuid: string[]) => {
  // change all uuids in array into 'user_role_ids[]=uuid' structure
  const transformedRolesUuid = rolesUuid?.map((uuid) => {
    return `user_role_ids[]=${uuid}`
  })

  // transform array of new uuids structure to string
  const rolesUuidsToString = transformedRolesUuid?.join()

  // replace all comas with '&' sign
  const rolesUuidsWithChangedComaToAmpersand = rolesUuidsToString?.replace(/,/g, '&')

  return rolesUuidsWithChangedComaToAmpersand ?? ''
}
